import { useCallback } from 'react';

import { ClassesTabbedPage } from '../../components/classes-tabbed-page';
import { GroupsEditor } from './groups-editor';

export const ClassesGroups = () => {
  const getContent = useCallback(() => <GroupsEditor />, []);
  return <ClassesTabbedPage tabContent={getContent} />;
};
